import { render, staticRenderFns } from "./page-tab-header.vue?vue&type=template&id=08b84d3e&scoped=true"
import script from "./page-tab-header.vue?vue&type=script&lang=js"
export * from "./page-tab-header.vue?vue&type=script&lang=js"
import style0 from "./page-tab-header.vue?vue&type=style&index=0&id=08b84d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b84d3e",
  null
  
)

export default component.exports